export default "__VITE_ASSET__CVQ$nUPV__"